module.exports = __webpack_public_path__ + "img/user-face-2.5fd2b23e.jpg";